import {Button, CommonInput, Image, InputErrors, PrimaryButton, RadioButton} from "../../../common";
import chat from "../../../../assets/images/icons/chat-dots.svg";
import React, {FormEvent, useEffect, useRef, useState} from "react";
import RadioButtonGroup, {Direction} from "../../../common/form/RadioButtonGroup/RadioButtonGroup";
import {PrimaryButtonColor} from "../../../common/buttons/decorators/PrimaryButton/PrimaryButton";
import {createChatManager} from "../../../../di";
import {useEffectOnUpdate, useErrorCallback} from "../../../../hooks";
import {MessageForm} from "../../../../api-client";
import {Errors as ValidationErrors} from "../../../../utils";
import styles from "./Chat.module.scss";

export type FormErrors = {
  receiverCode?: ValidationErrors;
  message?: ValidationErrors;
  subject?: ValidationErrors;
}

const maxMessageLength = 1000;
const maxSubjectLength = 100;

export const Chat= () => {
  const [isClick, setIsClick] = useState(false);
  const handleError = useErrorCallback();
  const [formData, setFormData] = useState<MessageForm>({
    messageType: "platform",
    receiverCode: "",
    subject: "",
    message: "",
  });
  const [errors, setErrors] = useState<FormErrors>({});

  const chatRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (chatRef.current && !chatRef.current.contains(event.target as Node)) {
        setIsClick(false);
      }
    };

    if (isClick) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isClick]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const chatManager = await createChatManager();
      await chatManager.sendMessageForm(formData);
      alert('Your message was sent successfully');
      setFormData({
        messageType: "platform",
        receiverCode: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      if (error instanceof Error) {
        await handleError(error);
        alert(`Error: ${error.message}`);
      }
    } finally {
      setIsClick(false);
    }
  };

  const handleChange = (param: keyof MessageForm, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [param]: value,
    }));
  };
  const validateBlock = (): boolean => {
    const errors: FormErrors = {};
    if (formData.receiverCode && formData.receiverCode.length !== 6) {
      errors.receiverCode = ["Неверный формат ID"];
    }
    if (formData.receiverCode === "" && formData.messageType === "user") {
      errors.receiverCode = ["Введите ID пользователя"];
    }
    if (formData.message === "") {
      errors.message = ["Введите сообщение"];
    }
    if (formData.message && formData.message.length > maxMessageLength) {
      errors.message = [`Сообщение не должно превышать ${maxMessageLength} символов`];
    }
    if (formData.subject && formData.subject.length > maxSubjectLength) {
      errors.subject = [`Тема не должна превышать ${maxSubjectLength} символов`];
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffectOnUpdate(() => {
    validateBlock();
  }, [
    formData.receiverCode,
    formData.message,
    formData.subject,
  ]);
  return (<div>
    <Image src={chat} alt="chat" className={styles.icon} onClick={() => setIsClick(prev => !prev)}/>
    {isClick && (
      <div className={styles.chat__wrapper} ref={chatRef}>
        <div className={styles.chat}>
          <div className={styles.chat__container}>
            <p>Новое сообщение</p>
            <RadioButtonGroup direction={Direction.HORIZONTAL}>
              <RadioButton
                name="messageType"
                value="platform"
                checked={formData.messageType === "platform"}
                onChange={() =>
                  setFormData((prev) => ({
                    ...prev,
                    messageType: "platform",
                    email: "",
                  }))
                }
              >
                сообщение платформе
              </RadioButton>

              <RadioButton
                name="messageType"
                value="user"
                checked={formData.messageType === "user"}
                onChange={() =>
                  setFormData((prev) => ({
                    ...prev,
                    messageType: "user",
                  }))
                }
              >
                сообщение другому пользователю
              </RadioButton>
            </RadioButtonGroup>

            <form className={styles.form} onSubmit={handleSubmit}>
              {formData.messageType === "user" && (
                <CommonInput
                  id="receiverCode"
                  title="укажите ID пользователя"
                  value={formData.receiverCode}
                  onChange={(value) => handleChange('receiverCode', value)}
                  required
                />
              )}
              <CommonInput
                id="subject"
                title="тема"
                value={formData.subject}
                onChange={(value) => handleChange('subject', value)}
                required
              />
              <textarea
                id="message"
                value={formData.message}
                onChange={(e) => handleChange('message', e.target.value)}
                className={styles.textarea}
                placeholder="сообщение"
                required
              />
              {errors.receiverCode && <InputErrors errors={errors.receiverCode}/>}
              {errors.message && <InputErrors errors={errors.message}/>}
              {errors.subject && <InputErrors errors={errors.subject}/>}
              <PrimaryButton color={PrimaryButtonColor.GRAY} disabled={Object.keys(errors).length === 0}>
                <Button type="submit">Отправить</Button>
              </PrimaryButton>
            </form>
          </div>
        </div>
      </div>
    )}
  </div>
  );
};